import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './components/Home';
import AboutUs from './components/AboutUs';
import Footer from './components/Footer';
import CocoProducts from './components/pages/CocoProductpage';
import ContactUs from './components/ContactUs';
import Preparation from './components/Preparation';
import ProductDetail from './components/pages/ProductDetail';
import Cocopeat5kgBricks from './components/pages/Coco5kgBricks';
import Cocopeat25kgBricks from './components/pages/Coco25kgbricks';
import ScrollToTop from './components/ScrolltoTop';
import BulkLoads from './components/pages/BulkLoads';
import Cocopeat650gm from './components/pages/Coco650gm';
import Cocopeat1kgBricks from './components/pages/Coco1kgbrick';
import CocopeatDiscs from './components/pages/CocopeatDisc';

const App = () => {
  return (
    <Router>
      <Navbar />
      <ScrollToTop/>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/aboutus" element={<AboutUs />} />
        <Route path="/products" element={<CocoProducts />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/product/:id" element={<ProductDetail />} />
        <Route path="/product/cocopeat-650gm" element={<Cocopeat650gm />}/>
        <Route path="/product/1kg-bricks" element={<Cocopeat1kgBricks />}/>
        <Route path="/product/5kg-bricks" element={<Cocopeat5kgBricks />}/>
        <Route path="/product/25kg-bricks" element={<Cocopeat25kgBricks />}/>
        <Route path="/product/cocopeat-coins" element={<CocopeatDiscs />}/>
        <Route path="/product/bulk-loads" element={<BulkLoads />}/>


        <Route path="/process" element={<Preparation />} />
      </Routes>
      <Footer/>
    </Router>
  );
};

export default App;
